<template>
    <div class="payment-chart-table">
        <div class="container-width">
            <h2 id="savingsBreakdownSection" class="section-title">{{ section4HeadersAndSubHeaders.section4HeaderText }}</h2>
            <p class="sub-heading">{{ section4HeadersAndSubHeaders.section4SubHeaderText }}</p>
            <div>
                <table v-for="(option, index) in savingsJson" id="savingsBreakdownTable" :key="index" class="table" :class="{active: getActive(option.savingName)}">
                    <thead>
                        <tr>
                            <th>
                                <label class="table-trigger" @click="toggleActive(option.savingName)">
                                    <span class="lt4-ChevronRight"></span> {{ option.savingName }}
                                </label>
                                <button type="submit" class="active desktop-view btn btn-blue see-details" @click="toggleActive(option.savingName);trackSavingClick(option)">{{ section4HeadersAndSubHeaders.section4SeeDetailsButtonText }}</button>
                            </th>
                            <th class="desktop-view">{{ section4HeadersAndSubHeaders.section4TableHeaderText1 }} <lt-label /><big>{{ formatCurrency(option.debtAmount) }}</big></th>
                            <th class="desktop-view">{{ section4HeadersAndSubHeaders.section4TableHeaderText2 }} <lt-label /><big>{{ formatCurrency(option.debtNotCovered) }}</big></th>
                            <th class="desktop-view">{{ section4HeadersAndSubHeaders.section4TableHeaderText3 }} <lt-label /><big>{{ formatCurrency(option.interest) }}</big></th>
                            <th class="desktop-view">{{ section4HeadersAndSubHeaders.section4TableHeaderText4 }} <lt-label /> <big>{{ formatCurrency(option.monthlyPayment) }}</big></th>
                            <th class="desktop-view">{{ section4HeadersAndSubHeaders.section4TableHeaderText5 }} <lt-label /> <big>{{ formatCurrency(option.totalSavings) }}</big></th>
                        </tr>
                    </thead>
                    <tbody class="active desktop-view">
                        <tr>
                            <td v-if="option.outstandingDebtPayments.length>0" :rowspan="option.outstandingDebtPayments.length + 3" class="saving-detail">
                                {{ option.outstandingDebtPayments[0].detailText }}
                            </td>
                            <td colspan="5" class="outstanding-payment no-padding">
                                <table class="table" :class="{active: getActive(option.savingName)}">
                                    <tr v-if="option.outstandingDebtPayments.length>0"><td colspan="6" class="outstanding-payment"> {{ section4HeadersAndSubHeaders.section4TableCurrentDebtCoveredHeaderText }} </td></tr>
                                    <tr v-if="option.outstandingDebtPayments.length>0">
                                        <td colspan="2" class="outstanding-payment">{{ section4HeadersAndSubHeaders.section4SubTableHeaderText1 }}</td>
                                        <td class="outstanding-payment">{{ section4HeadersAndSubHeaders.section4SubTableHeaderText2 }}</td>
                                        <td class="outstanding-payment">{{ section4HeadersAndSubHeaders.section4SubTableHeaderText3 }}</td>
                                        <td class="outstanding-payment">{{ section4HeadersAndSubHeaders.section4SubTableHeaderText4 }}</td>
                                    </tr>
                                    <tr v-for="(debtPayment, debtPaymentIndex) in option.outstandingDebtPayments" :key="debtPaymentIndex">
                                        <td colspan="2" class="text-center">{{ debtPayment.debtPaymentType }}</td>
                                        <td>{{ formatOutstandingPayment(debtPayment.debtAmount) }}</td>
                                        <td>{{ formatOutstandingPayment(debtPayment.interest) }}</td>
                                        <td>{{ formatOutstandingPayment(debtPayment.monthlyPayment) }} </td>
                                    </tr>
                                    <tr>
                                        <td v-if="option.outstandingDebtPayments.length == 0" class="no-debt"></td>
                                        <td colspan="6" class="btn-offers">
                                            <a type="submit" class="btn btn-orange" :href="option.targetURL" target="_blank" @click="trackSavingOffers(option,'savingClicked')">{{ option.buttonText }}</a>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                    <tbody class="active mob-view">
                        <tr>
                            <td>
                                <div class="col-xs-12 mob-view-header">
                                    <div class="col-xs-4 mob-view-header-item">
                                        <label class="col-xs-6">{{ section4HeadersAndSubHeaders.section4TableHeaderText5 }}<lt-label /></label>
                                        <big class="col-xs-6">{{ formatCurrency(option.totalSavings) }}</big>
                                    </div>
                                    <div class="col-xs-4 mob-view-header-item">
                                        <label class="col-xs-6">{{ section4HeadersAndSubHeaders.section4TableHeaderText4 }} <lt-label /></label>
                                        <big class="col-xs-6">{{ formatCurrency(option.monthlyPayment) }}</big>
                                    </div>
                                    <div class="col-xs-4 mob-view-header-item">
                                        <label class="col-xs-6">{{ section4HeadersAndSubHeaders.section4TableHeaderText3 }}<lt-label /></label>
                                        <big class="col-xs-6">{{ formatCurrency(option.interest) }}</big>
                                    </div>
                                    <div class="col-xs-4 mob-view-header-item">
                                        <label class="col-xs-6">{{ section4HeadersAndSubHeaders.section4TableHeaderText1 }}<lt-label /></label>
                                        <big class="col-xs-6">{{ formatCurrency(option.debtAmount) }}</big>
                                    </div>
                                    <div class="col-xs-4 mob-view-header-item">
                                        <label class="col-xs-6">{{ section4HeadersAndSubHeaders.section4TableHeaderText2 }}<lt-label /></label>
                                        <big class="col-xs-6">{{ formatCurrency(option.debtNotCovered) }}</big>
                                    </div>
                                </div>
                                <div class="col-xs-12 sub-total mob-view-header">
                                    <div class="col-xs-12 coverage-text">{{ section4HeadersAndSubHeaders.section4TableCurrentDebtCoveredHeaderText }}</div>
                                    <div class="col-xs-12 coverage-item">
                                        <ul class="padding-fix"><li>{{ section4HeadersAndSubHeaders.mobSection4TableHeaderText1 }}</li><li>{{ section4HeadersAndSubHeaders.mobSection4TableHeaderText2 }}</li><li>{{ section4HeadersAndSubHeaders.mobSection4TableHeaderText3 }}</li></ul>
                                    </div>
                                </div>
                                <ul v-for="(debtPayment, debtPaymentIndex) in option.outstandingDebtPayments" :key="debtPaymentIndex" class="sub-total">
                                    <li>{{ debtPayment.debtPaymentType }}</li>
                                    <li>{{ formatOutstandingPayment(debtPayment.debtAmount) }} </li>
                                    <li>{{ formatOutstandingPayment(debtPayment.interest) }} </li>
                                    <li>{{ formatOutstandingPayment(debtPayment.monthlyPayment) }} </li>
                                </ul>
                                <div class="btn-offers">
                                    <a type="submit" class="btn btn-orange" :href="option.targetURL" target="_blank" @click="trackSavingOffers(option,'savingClicked')">{{ option.buttonText }}</a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import Accounting from 'accounting';
    import { isNullOrUndefined } from '~/helpers/util';
    import DefaultTooltip from '~/constants/tooltip-defaults';
    import LtLabel from '~/components/lt-label.vue';
    import { trackSavingOffersRedirect, trackSavingDetailClick } from '~/services/debt-management-advisor-tracking';

    export default {
        props: {
            debtCoveredTooltip: {
                default: DefaultTooltip.DebtCovered,
            },
            interestTooltip: {
                default: DefaultTooltip.Interest,
            },
            monthlyPaymentTooltip: {
                default: DefaultTooltip.MonthlyPayment,
            },
            savingsJson: {
                default: () => [],
            },
            debtNotCoveredTooltip: {
                default: DefaultTooltip.DebtNotCovered,
            },
            dialSelection: {
                default: '',
            },
            section4HeadersAndSubHeaders: {
                default() {
                    return {
                        section4HeaderText: 'Savings Breakdown',
                        section4SubHeaderText: 'Here’s how each option stacks up in terms of overall savings. Adjustments made above will be reflected here.',
                        section4SeeDetailsButtonText: 'See Details',
                        section4TableHeaderText1: 'Debt Covered:',
                        section4TableHeaderText2: 'Debt Not Covered:',
                        section4TableHeaderText3: 'Interest:',
                        section4TableHeaderText4: 'Mo. Payment:',
                        section4TableHeaderText5: 'Est. Savings:',
                        section4TableCurrentDebtCoveredHeaderText: 'Current Debt Covered',
                        mobSection4TableHeaderText1: 'Debt Covered',
                        mobSection4TableHeaderText2: 'Est. Interest',
                        mobSection4TableHeaderText3: 'Mo. Payment',
                        section4SubTableHeaderText1: 'Debt Type',
                        section4SubTableHeaderText2: 'Debt Amount',
                        section4SubTableHeaderText3: 'Est. Interest',
                        section4SubTableHeaderText4: 'Mo. Payment',
                    };
                },
            },
        },
        data() {
            return {
                isActive: [
                    { type: 'Debt Settlement', status: false },
                    { type: 'Balance Transfer Card', status: false },
                    { type: 'Home Equity Loan', status: false },
                    { type: 'Personal Loan', status: false }],
                DebtCoveredTooltip: parseInt(this.hideTooltip, 10) ? '' : this.debtCoveredTooltip,
                InterestTooltip: parseInt(this.hideTooltip, 10) ? '' : this.interestTooltip,
                MonthlyPaymentTooltip: parseInt(this.hideTooltip, 10) ? '' : this.monthlyPaymentTooltip,
                DebtNotCoveredTooltip: parseInt(this.hideTooltip, 10) ? '' : this.debtNotCoveredTooltip,
                DialSelection: this.dialSelection,
            };
        },
        methods: {
            formatCurrency(value) {
                if (!isNullOrUndefined(value)) return `$${this.currencyFilter(value)}`;
                return 'N/A';
            },
            formatOutstandingPayment(value) {
                if (!isNullOrUndefined(value)) return `$${this.currencyFilter(value)}`;
                return '-';
            },
            currencyFilter(figure) {
                return Accounting.formatNumber(figure, { precision: 2 });
            },
            toggleActive(type, isDataUpdated) {
                this.isActive = this.isActive.map((item) => {
                    if (item.type.toLowerCase() === type.toLowerCase()) {
                        if (isDataUpdated) item.status = true;
                        else item.status = !item.status;
                    } else {
                        item.status = false;
                    }
                    return item;
                });
            },
            trackSavingOffers(savingOption, text) {
                trackSavingOffersRedirect(savingOption, text);
            },
            trackSavingClick(savingOption) {
                trackSavingDetailClick(savingOption);
            },
            toggleSection(data, isDataUpdated = false) {
                this.toggleActive(data, isDataUpdated);
            },
            getActive(option) {
                const filteredArr = this.isActive.filter((item) => {
                    let result = false;
                    if (item.status === true && item.type.toLowerCase() === option.toLowerCase()) {
                        result = item.status;
                    }
                    return result;
                });
                return filteredArr[0] ? filteredArr[0].status : false;
            },
        },
        watch: {
            dialSelection() {
                this.toggleSection(this.dialSelection, true);
            },
            savingsJson() {
                if (this.savingsJson[0]) {
                    this.toggleSection(this.savingsJson[0].savingName, true);
                }
            },
        },
        components: {
            LtLabel,
        },
        mixins: [Accounting],
    };
</script>
<style lang="scss" src="../../../assets/styles/amortization-breakdown-table.scss"></style>
